import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { apiService } from '../services/api';
import { ContentNodeResponse, ContentNodeTranslation } from '../types';

interface UseContentNodeResult {
  node: ContentNodeResponse | null;
  translation: ContentNodeTranslation | null;
  loading: boolean;
  error: string | null;
}

export function useContentNode(slug: string): UseContentNodeResult {
  const { i18n } = useTranslation();
  const [node, setNode] = useState<ContentNodeResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    void apiService.contentNodes.getBySlug(slug)
      .then(res => setNode(res.data))
      .catch(() => setError(i18next.t('common.loadFailed', 'Failed to load')))
      .finally(() => setLoading(false));
  }, [slug]);

  const locale = i18n.language;
  const translation = node
    ? (node.translations.find(t => t.locale === locale && t.published) ??
       node.translations.find(t => t.published) ??
       null)
    : null;

  return { node, translation, loading, error };
}
